// LIVE
export const BASEURL = "https://api.aliff.in/api";
export const IMAGEURL = "https://api.aliff.in";
export const DASHBOARD_REGISTER_URL = "https://app.aliff.in/register";
export const DASHBOARD_LOGIN_URL = "https://app.aliff.in/";
export const LMS_API = "https://api-lms.aliff.in/api";
export const PAYU_PAYMENT_LINK = "https://secure.payu.in/_payment";

// STG
// export const BASEURL = "https://api-alif.binarynumbers.io/api";
// export const IMAGEURL = "https://api-alif.binarynumbers.io";
// // export const IMAGEURL = "https://api.aliff.in";
// export const DASHBOARD_REGISTER_URL =
//   "https://student-dashboard-alif.binarynumbers.io/register";
// export const DASHBOARD_LOGIN_URL =
//   "https://student-dashboard-alif.binarynumbers.io/";
// export const LMS_API = "https://api-stg-lms.aliff.in/api";

// DEV
// export const BASEURL = "http://localhost:8002/api";
// export const IMAGEURL = "http://localhost:8002";
// export const DASHBOARD_REGISTER_URL = "https://localhost:8080/register";
// export const DASHBOARD_LOGIN_URL = "https://localhost:8080";
// // export const LMS_API = "https://api-stg-lms.aliff.in/api";
// export const LMS_API = "http://localhost:9003/api";

export const API_VERSION = "v1.0";



// WEBPACK FOOTER //
// ./src/config/index.js